import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class LabelQueryCriteriaClass extends BaseCriteriaModel {
  guid?: Optional<string> = Optional.empty();
  guid_parent?: Optional<string> = Optional.empty();
  level_value?: Optional<string> = Optional.empty();
  txn_type?: Optional<string> = Optional.empty();
  code?: Optional<string> = Optional.empty();
  name?: Optional<string> = Optional.empty();
  descr?: Optional<string> = Optional.empty();
  label_type?: Optional<string> = Optional.empty();
  label_list_guid?: Optional<string> = Optional.empty();
  param_code?: Optional<string> = Optional.empty();
  param_name?: Optional<string> = Optional.empty();
  param_type?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();

  guids?: Optional<string> = Optional.empty(); /** @param guids is comma separated E.g: 4BC80017-22CC-4A29-9511-E22C4EB97AD5,4BC80017-22CC-4A29-9511-E22C4EB97AD5*/
}

export class LabelCriteriaModelQuery {
  query = '';

  constructor(labelCriteriaModel: LabelQueryCriteriaClass) {

    if (!labelCriteriaModel) {
      return;
    }

    // this.query += LabelQueryCriteriaClass.convertOptionalStringToQueryParms(labelCriteriaModel.guid_parent, 'guid_parent' );
    this.query += labelCriteriaModel.guid.filter(x => x !== '').map(x => '&guid=' + x).orElse('');
    this.query += labelCriteriaModel.guid_parent.filter(x => x !== '').map(x => '&guid_parent=' + x).orElse('');
    this.query += labelCriteriaModel.level_value.filter(x => x !== '').map(x => '&level_value=' + x).orElse('');
    this.query += labelCriteriaModel.txn_type.filter(x => x !== '').map(x => '&txn_type=' + x).orElse('');
    this.query += labelCriteriaModel.code.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += labelCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += labelCriteriaModel.descr.filter(x => x !== '').map(x => '&descr=' + x).orElse('');
    this.query += labelCriteriaModel.label_type.filter(x => x !== '').map(x => '&label_type=' + x).orElse('');
    this.query += labelCriteriaModel.label_list_guid.filter(x => x !== '').map(x => '&label_list_guid=' + x).orElse('');
    this.query += labelCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += labelCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += labelCriteriaModel.param_type.filter(x => x !== '').map(x => '&param_type=' + x).orElse('');
    this.query += labelCriteriaModel.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');
    this.query += labelCriteriaModel.guids.filter(x => x !== '').map(x => '&guids=' + x).orElse('');


    this.query += '&status=' + labelCriteriaModel.status;
    // this.query += '&orderBy=' + labelCriteriaModel.orderBy;
    this.query += '&order=' + labelCriteriaModel.order;
    this.query += '&offset=' + labelCriteriaModel.offset;
    this.query += '&limit=' + labelCriteriaModel.limit;
  }
}
